<div class="alarm_screen" style="box-shadow: 1px 3px 1px #80808024;">
  <div class="alarm_container">
    <div class="alarm_header">
      <h4 style="text-transform:capitalize">Update Onboarding</h4>
    </div>
    <div class="alarm_body" style="padding: 1px 25px 5px 25px">
      <div class="row">
        <label>Account ID</label>
        <input type="text" class="form-control" [(ngModel)]="ri.accountId" readonly>
      </div>
      <div class="row">
        <label>Account Name</label>
        <input type="text" class="form-control" [(ngModel)]="ri.accountName" readonly>
      </div>
      <div class="row">
        <label>Bucket Name</label>
        <input type="text" class="form-control" [(ngModel)]="res.bucketName" placeholder="Bucket Name">
      </div>
      <div class="row">
        <label>Folder Name</label>
        <input type="text" class="form-control" [(ngModel)]="res.folderName" placeholder="Folder Name">
      </div>
      <div class="row">
        <label>Enable Billing conductor</label>
        <div style="display: inline-flex; gap:12px;">
          <div>
            <input type="radio" id="policyYes" name="enablePolicy" [(ngModel)]="res.billingConductorEnabled" [value]="true" (change)="onPolicyChange(true)">
            <label for="policyYes">Yes</label>
          </div>
          <div>
            <input type="radio" id="policyNo" name="enablePolicy" [(ngModel)]="res.billingConductorEnabled" [value]="false" (change)="onPolicyChange(false)">
            <label for="policyNo">No</label>
          </div>
        </div>
      </div>

      <div class="row">
        <label>Billing to only Swayam Onboarded Account</label>
        <div style="display: inline-flex; gap:12px;">
          <div>
            <input type="radio" id="billingInSwayamYes" name="billingInSwayam" [(ngModel)]="res.billingInSwayam" [value]="true" (change)="onPolicyChange(true)">
            <label for="policyYes">Yes</label>
          </div>
          <div>
            <input type="radio" id="billingInSwayamNo" name="billingInSwayam" [(ngModel)]="res.billingInSwayam" [value]="false" (change)="onPolicyChange(false)">
            <label for="policyNo">No</label>
          </div>
        </div>
      </div>

      <div class="row">
        <label>Master Account Visibility in Swayam </label>
        <div style="display: inline-flex; gap:12px;">
          <div>
            <input type="radio" id="visibilityInSwayamYes" name="visibilityInSwayam" [(ngModel)]="res.visibilityInSwayam" [value]="true" (change)="onPolicyChange(true)">
            <label for="visibilityInSwayamYes">Yes</label>
          </div>
          <div>
            <input type="radio" id="visibilityInSwayamNo" name="visibilityInSwayam" [(ngModel)]="res.visibilityInSwayam" [value]="false" (change)="onPolicyChange(false)">
            <label for="visibilityInSwayamNo">No</label>
          </div>
        </div>
      </div>

      <div *ngIf="res.billingConductorEnabled">
        <div class="row">
          <label>Billing conductor Bucket Name</label>
          <input type="text" class="form-control" [(ngModel)]="res.billingConductorBucketName" placeholder="Bucket Name">
        </div>
        <div class="row">
          <label> Billing conductor Folder Name</label>
          <input type="text" class="form-control" [(ngModel)]="res.billingConductorFolderName" placeholder="Folder Name">
        </div>
      </div>

      <div class="row mb-2">
        <label>Multi Bucket</label>
        <div style="display: inline-flex; gap: 12px;">
          <div>
            <input type="radio" id="multiBucketYes" name="multiBucket" [(ngModel)]="res.multiBucket" [value]="true" (change)="multiBucketChange(true)">
            <label for="multiBucketYes">Yes</label>
          </div>
          <div>
            <input type="radio" id="multiBucketNo" name="multiBucket" [(ngModel)]="res.multiBucket" [value]="false" (change)="multiBucketChange(false)">
            <label for="multiBucketNo">No</label>
          </div>
        </div>
      </div>
      
      <div *ngIf="res.multiBucket">
        <div *ngFor="let item of tempBucketInputs; let i = index">
          
          <!-- Bucket Name -->
          <div class="row mb-2">
              <label>Bucket Name</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="item.bucket"
                [readonly]="i < res.multiBucketList.length"
                placeholder="Bucket Name" />
          </div>
      
          <!-- Folder Name -->
          <div class="row mb-2">                
            <label>Folder Name</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="item.folder"
                placeholder="Folder Name" />
            </div>
      
          <!-- Region -->
          <div class="row mb-2">              
            <label>Region</label>
              <select
                class="form-control selectpicker"
                data-live-search="true"
                [(ngModel)]="item.region"
                [attr.id]="'regionsList' + i">
                
                <!-- Show unmatched region -->
                <option *ngIf="isRegionUnmatched(item.region)" [value]="item.region">
                  {{ item.region }}
                </option>
      
                <!-- Show matched regions -->
                <option *ngFor="let region of regions" [value]="region.id">
                  {{ region.name }}
                </option>
              </select>
            </div>

            <div class="row mb-2">              
              <label>Child Accounts</label>
              <select
                class="form-control selectpicker"
                data-live-search="true"
                [(ngModel)]="item.childs"
                [attr.id]="'childAccounts' + i"
                multiple>
                <option *ngFor="let account of childAccounts" [value]="account.id">
                  {{ account.name }} {{ account.id }}
                </option>
              </select>
            </div>
            
      
          <!-- Delete Button (only for new entries) -->
          <div class="row mb-3 align-items-center">
            <div class="col-md-1 d-flex align-items-end">
              <button
                class="btn btn-danger"
                type="button"
                (click)="deleteBucketInput(i)">
                Delete
              </button>

            </div>
          </div>
      
        </div>
      
        <!-- Add New Set -->
        <div class="text-right mt-2">
          <button class="btn btn-primary" type="button" (click)="addBucketInput()">+ Add</button>
        </div>
      </div>
      
      
      <div class="alarm_actions">
        <div style="display: flex; justify-content: flex-end">
          <button class="btn" (click)="updateEntry()"
            
            style="background-color: #5864ff; color: white; text-transform:capitalize; margin-right:20px">
            Update
          </button>
          <!-- [disabled]="!res.billingConductorEnabled" -->
          <button class="btn btn-light" (click)="close()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>



  <style>
    .alarm_screen label {
      padding: 0 !important;
    }
  </style>